import { FC, useEffect } from 'react';
import { ThisWorkflowStep } from '@components/WorkflowCard/types';
import { WORKFLOW_ACTIONS, Workflow, WORKFLOW_REFERENCE_TYPES } from '@typings/api-models';
import useNoodleApi from '@hooks/useNoodleApi';
import getProductById from '@tsClient/getProductById';
import ProgressIndicator from '@components/ProgressIndicator';
import CreateEditDocumentRequestForm from '@components/CreateEditDocumentRequestForm';
import CreateEditSendMessageActionForm from '@components/CreateEditSendMessageActionForm';
import { SendMessageActionData } from '@components/CreateEditSendMessageActionForm/CreateEditSendMessageActionForm';

type Props = {
  action: ThisWorkflowStep;
  workflow: Pick<Workflow, 'id' | 'referenceId' | 'referenceType'>;
  onFinishEdit: () => void;
};

const ActionEditForm: FC<Props> = ({ action, onFinishEdit, workflow }) => {
  // Getting the product data here is temporary until everything is stored on the step
  // Usually, this data should be fetched by the child component
  const {
    data: productData,
    getData: getProduct,
  } = useNoodleApi(getProductById);

  useEffect(() => {
    if (workflow.referenceId && workflow.referenceType === WORKFLOW_REFERENCE_TYPES.PRODUCT) {
      getProduct({ id: workflow.referenceId });
    }
  }, [workflow]);

  if (action.eventName === WORKFLOW_ACTIONS.SEND_MESSAGE) {
    if (!productData) {
      return <ProgressIndicator isCentered />;
    }
    return <CreateEditSendMessageActionForm
      actionId={action.id}
      messageData={action.data as SendMessageActionData}
      workflowId={workflow.id}
      onSave={onFinishEdit}
    />;
  }
  if (action.eventName === WORKFLOW_ACTIONS.SEND_DOCUMENT_REQUEST) {
    return <CreateEditDocumentRequestForm />;
  }
  return null;
};

export default ActionEditForm;
